import { useState } from "react";
import REMALogo from "../../assets/REMA/logo.svg";
import {
  NAV_HEIGHT,
  REMA_LANDING_PAGE_URL,
  REMA_REGISTRATION_PAGE_URL,
} from "./constants";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import { Link } from "react-router-dom";
import EventCountdownTimer from "./EventCountdownTimer";
import { List, X } from "phosphor-react";
import DownloadBrochureButton from "./DownloadBrochureButton";

gsap.registerPlugin(ScrollTrigger);

const Navbar = ({ navToggle }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav
      className={` text-white fixed  z-50  font-sora w-full backdrop-blur-sm bg-[#11302D1A] flex items-center ${
        navToggle ? "opacity-0 top-[86px]" : "block opacity-100 top-0"
      } transition-all duration-300 ease-in-out`}
    >
      <div className="container mx-auto" style={{ height: NAV_HEIGHT }}>
        <div className="flex items-center justify-between h-full px-4">
          {/* Logo Section */}
          <div className="flex items-center">
            <Link to={REMA_LANDING_PAGE_URL} className="flex-shrink-0">
              <img
                src={REMALogo}
                alt="REMA Conference"
                className="h-full w-auto"
              />
            </Link>
          </div>

          {/* Countdown Timer - Hidden on mobile, visible on larger screens */}
          <div className="hidden lg:flex items-center">
            <EventCountdownTimer />
          </div>

          {/* Register Button - Desktop */}
          <div className="hidden lg:block">
            {/* <Link
              to={REMA_REGISTRATION_PAGE_URL}
              className="bg-light-green-500 hover:bg-light-green-600 text-green-800 font-semibold py-3 px-8  transition duration-300 ease-in-out transform  text-sm block text-center"
            >
              Register now
            </Link> */}
            <DownloadBrochureButton />
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              onClick={toggleMenu}
              className="text-[#CBF07F] hover:text-green-200 focus:outline-none focus:text-green-200 p-2"
            >
              {isMenuOpen ? <X size={24} /> : <List size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden bg-green-700 p-4  w-fill">
            {/* Mobile Countdown Timer */}
            <EventCountdownTimer />

            {/* Mobile Register Button */}
            {/* <div className="text-center w-full mt-4">
              <Link
                className="bg-light-green-500 hover:bg-light-green-600 text-green-800 font-semibold py-3 px-6 w-full transition duration-300 ease-in-out text-sm block text-center "
                to={REMA_REGISTRATION_PAGE_URL}
              >
                Register now
              </Link>
            </div> */}
            <DownloadBrochureButton />
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
